import { AplicacaoImposto } from 'px-business-components';

export function getTipoAplicacaoIcms(icms) {
  return icms > 0 ? AplicacaoImposto.keys.INCLUSO.key : AplicacaoImposto.keys.ISENTO.key;
}

export function getTipoAplicacaoIpi(ipi) {
  return ipi > 0 ? AplicacaoImposto.keys.CALCULAR.key : AplicacaoImposto.keys.ISENTO.key;
}
